import React, { Component } from 'react';
import { CircularProgress, Typography } from '@material-ui/core';
import { commonResourceStyle } from '../../css/style';

const styles = commonResourceStyle();

class LoadingBar extends React.Component {
  render() {
    return (
        <div style={styles.loadingContainer}>
            <CircularProgress size={80} />
            <Typography style={styles.loadingText}>Loading</Typography>
        </div>
    );
  }
}

export default LoadingBar;
